import { isAndroidWebView } from "@/lib/inAppOAuth";

// Abre una URL dentro del navegador in-app (overlay con toolbar + iframe).
//
// REGLA DE ENLACES EXTERNOS:
//   - Android WebView (APK nativo): abre en el navegador integrado de la app
//     (overlay a pantalla completa con toolbar). Antes de mostrarlo, cierra
//     cualquier modal/dialog abierto para que el navegador sea la pantalla
//     visible (no queda oculto detrás de un modal z-200).
//   - Móvil no-Android, PWA y escritorio: los enlaces externos abren en una
//     NUEVA PESTAÑA del navegador del sistema (target="_blank"). La función
//     devuelve false para que el llamador caiga al comportamiento por defecto.
//
// Despacha un evento global que InAppBrowser (montado en la raíz de la app)
// escucha y atiende. Devuelve true si un provider lo atendió (Android),
// false si nadie lo manejó (el llamador debe caer a nueva pestaña).
export function openInAppBrowser(url) {
  if (!url) return false;
  // Solo el navegador integrado en Android WebView (APK nativo). En móvil
  // no-Android, PWA y escritorio los enlaces externos abren en nueva pestaña.
  if (!isAndroidWebView()) return false;
  // Cierra modales/dialogs abiertos antes de mostrar el navegador integrado.
  closeAllOpenModals();
  try {
    const handled = !window.dispatchEvent(
      new CustomEvent("bhgc-open-inapp-browser", { detail: { url }, cancelable: true })
    );
    return handled;
  } catch {
    return false;
  }
}

// Abre una URL externa con la regla de enlaces aplicada. Úsalo cuando el
// llamador no sea un <a target="_blank"> (ej. botones que abren una función o
// una URL de etiqueta/rastreo). En Android abre el navegador integrado; en
// el resto abre una nueva pestaña. Garantiza que el enlace siempre se abra
// sin importar la plataforma.
export function openExternalLink(url) {
  if (!url) return;
  if (openInAppBrowser(url)) return;
  // No-Android: nueva pestaña del navegador del sistema.
  window.open(url, "_blank", "noopener,noreferrer");
}

// Cierra todos los modales/dialogs abiertos antes de abrir el navegador
// integrado en Android. Radix Dialog/AlertDialog/Sheet/DropdownMenu/Popover
// exponen data-state="open" y cierran al recibir Escape; los portales custom
// (z-200) quedan cubiertos por el overlay del navegador (z-[9999]).
function closeAllOpenModals() {
  try {
    // Radix UI: el content tiene data-state="open" y role dialog/alertdialog.
    // Dispatch Escape en cada overlay abierto para disparar onDismiss.
    const openEls = document.querySelectorAll('[data-state="open"]');
    openEls.forEach((el) => {
      try {
        el.dispatchEvent(
          new KeyboardEvent("keydown", {
            key: "Escape",
            code: "Escape",
            keyCode: 27,
            bubbles: true,
            cancelable: true,
          })
        );
      } catch {}
    });
    // Evento custom para modales propios que lo escuchen (portales con
    // onClose controlado por el padre y no por Radix).
    window.dispatchEvent(new CustomEvent("bhgc-close-all-modals"));
  } catch {}
}